import useAuth from "../../hooks/useAuth";
import './scss/NavBar.scss';

const NavBarDeveloper = () => {
  const { handleLogout } = useAuth();

  return (
    <nav className="dropdown-menu bg-white lg:absolute lg:mt-[45px] lg:shadow-lg lg:rounded-[5px] w-full lg:w-fit lg:right-[15px] lg:z-[100]">
      <ul className="w-max">
        <li className="w-fit">
          <ul className="w-fit">
            <li onClick={handleLogout}
              className="hover:bg-green200 hover:text-green700 text-[#212121] font-medium text-base py-2 lg:pl-2 lg:pr-6 rounded-lg">
              <button>Cerrar sesión</button>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  );
};

export default NavBarDeveloper;
